import React from 'react'
import { IoCloseOutline } from "react-icons/io5";
import { motion } from 'framer-motion'




const MaterialsModal = ({setModal, data}) => {
  return (
    <motion.div
     initial={{ scale: 0.5, opacity: 0 }}
     animate={{ scale: 1, opacity: [0.1, 0.1, 0.1, 0.3, 0.5, 0.7, 1] }}
     transition={{ duration: 0.7, ease: "easeIn" }}
     exit={{ opacity: 0, transition: { duration: 1.5, ease: "easeIn" } }}
     className='mb-10 w-full h-[95vh] z-50 bg-white pt-5 shadow-md rounded-xl md:pt-6 lg:-mt-24 mx-auto'>

        {/* TITLE */}
       <div className='flex items-start justify-between w-full px-3 md:px-5 md:items-center lg:px-7'>
          <p className='text-[11px] text-[#101828] font-semibold w-[75%] md:text-[12px] lg:text-sm xl:text-base'>
              {data.name}
          </p>
          <IoCloseOutline onClick={()=>setModal(false)} className='text-xl lg:text-2xl xl:text-3xl' />
       </div>

       {/* HORIZONTAL LINE */}
       <div className='w-full mt-2.5 bg-[#DDE1E6] border-[1px] border-dashed lg:mt-3.5'></div>

       {/* CONTENT */}
       <div className='px-3 mt-2.5 w-full overflow-y-auto max-h-[86vh] md:mt-3 md:px-5 md:max-h-[85vh] lg:max-h-[84vh] lg:px-7 xl:mt-4'>

       {data.contents.map((item, index) => (
       <div key={index} className='w-full'>
           <p className='text-[11px] text-[#101828] font-medium pt-1 md:text-[12px] md:leading-5 lg:text-[13px] lg:leading-[22px] xl:text-[15px] xl:leading-6'>
               {item.title}
           </p>

           <div className='w-full mb-10'>
               {item.lists.map((item, index) => (
               <div className='pt-3 lg:pt-4 xl:pt-6'>
                   <i key={index} className='text-[10px] text-[#101828] font-normal md:text-[12px] md:leading-5 lg:text-[13px] lg:leading-[22px] xl:text-[15px] xl:leading-6'>
                      {item}
                   </i>
               </div>
                ))}
            </div>

        </div>
        ))}
        
        </div>

    </motion.div>
  )
}

export default MaterialsModal
